export const CLOSE = 'baq/sideNav/bulkEditProfitItemsDrawer/CLOSE';
export const OPEN = 'baq/sideNav/bulkEditProfitItemsDrawer/OPEN';
